var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgButton2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_3344)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_45_3344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_45_3344)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_45_3344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_45_3344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.06988 0.00027714C3.59628 -0.0365229 -0.0365229 3.59628 0.00027714 8.06988C0.0378771 12.4139 3.58668 15.9635 7.92988 15.9995C12.4035 16.0379 16.0379 12.4035 15.9995 7.92988C15.9635 3.58748 12.4139 0.0378771 8.06988 0.00027714ZM5.67788 3.98188C6.18988 4.63228 6.49628 5.45548 6.49628 6.34828C6.49628 7.12188 6.26668 7.84188 5.87228 8.44268H3.09868L5.67708 3.98108L5.67788 3.98188ZM14.1339 8.85548V9.43148C14.1339 9.46908 14.1139 9.50108 14.0795 9.51548C13.8915 9.59548 13.2715 9.88348 13.0131 10.2419C12.3475 11.1683 11.8395 12.6243 10.7035 12.6243H5.96348C4.28508 12.6243 2.88108 11.2923 2.88188 9.51788C2.88188 9.47388 2.91948 9.43788 2.96348 9.43788H5.20988C5.28748 9.43788 5.34828 9.50028 5.34828 9.57628V10.0099C5.34828 10.2403 5.53468 10.4275 5.76588 10.4275H7.46988V9.43548H6.30588C6.97548 8.58748 7.37388 7.51708 7.37388 6.35148C7.37388 5.05148 6.87548 3.86588 6.05948 2.97948C6.55308 3.03708 7.02508 3.13548 7.46988 3.26588V2.98988C7.46988 2.70348 7.70188 2.47148 7.98828 2.47148C8.27468 2.47148 8.50668 2.70348 8.50668 2.98988V3.65548C10.0971 4.39788 11.1387 5.62988 11.1387 7.02348C11.1387 7.84108 10.7811 8.60188 10.1643 9.24188C10.0459 9.36428 9.88188 9.43388 9.70988 9.43388H8.50748V10.4243H10.0171C10.3427 10.4243 10.9267 9.80668 11.2035 9.43468C11.2035 9.43468 11.2155 9.41628 11.2475 9.40668C11.2795 9.39708 14.0195 8.76828 14.0195 8.76828C14.0771 8.75228 14.1339 8.79628 14.1339 8.85468V8.85548Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_3344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgButton2);
export default __webpack_public_path__ + "static/media/bg_button_2.90f8ca69a5b892a091f5464c9b3ac0d2.svg";
export { ForwardRef as ReactComponent };